<template>
  <div>
    <div class="mb-6">
      <StudentFilter :viewIsPaid="viewIsPaid" @onFilter="handleFilter" />
    </div>
    <v-card outlined>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :options.sync="pagination"
        :items-per-page="10"
        :server-items-length="totalItems"
        :headers="headers"
        :footer-props="footerTable"
        :items="listReports"
        sort-by="name"
        v-bind="this.$attrs"
        loading-text="Đang Tải"
        :loading="loading"
        :hide-default-footer="!listReports[0]"
      >
        <template v-slot:no-data>
          <StatusAction />
        </template>
        <template v-slot:[`item.stt`]="{ index }">
          {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <card-student-name :student="item.student" link />
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          <span v-if="item.student && item.student.dob">{{ item.student.dob | ddmmyyyy }}</span>
        </template>
        <template v-slot:[`item.currentClass`]="{ item }">
          <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
            <span v-if="item.class">{{ item.class.title || '' }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.isPaid`]="{ item }">
          <v-icon color="#46BE8A" v-if="item.isPaid">mdi-checkbox-marked-circle</v-icon>
          <v-icon color="#F4BB43" v-else>mdi-cancel</v-icon>
        </template>
        <template v-slot:[`item.moneyTotal`]="{ item }">
          <span>{{ countMoney(item.totalSumFee, item.totalMinusFee).toLocaleString('en-US') || '0' }} VNĐ</span>
        </template>
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip max-width="300px" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="note text-truncate">
                {{ item.notes }}
              </div>
            </template>
            <span class="tooltip white--text">{{ item.notes }} </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <ActionPeriod :isPaid="item.isPaid" :viewIsPaid="viewIsPaid" :report="item" />
        </template>
      </v-data-table>
      <div class="mb-7">
        <TotalPayment></TotalPayment>
      </div>
    </v-card>
  </div>
</template>

<script>
import StatusAction from './StatusAction.vue'
import StudentFilter from './StudentFilter.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { originHeaders } from './helper/headerStudent'
import ActionPeriod from '@/modules/tuitionFee/detail-period/action/ActionPeriod.vue'
import TotalPayment from './TotalPayment.vue'
export default {
  components: {
    StatusAction,
    StudentFilter,
    CardStudentName,
    ActionPeriod,
    TotalPayment,
  },
  data() {
    return {
      pagination: {},
      pageText: '',
      loading: false,
    }
  },
  computed: {
    viewIsPaid() {
      return this.$auth.policies['view-is-paid-period']
    },
    headers() {
      return originHeaders(this.viewIsPaid)
    },
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      totalItems: 'tuitionFeeReport/totalItems',
      ownClassIds: 'auth/ownClassIds',
      user: 'auth/user',
      reports: 'tuitionFeeReport/reports',
      customQuery: 'tuitionFeeReport/customQuery',
    }),
    listReports() {
      if (this.detailPeriod.status === 'finished') return this.reports
      else return []
    },
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học viên mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions({
      fetchReports: 'tuitionFeeReport/fetchReports',
      getTotalFee: 'tuitionFeePeriod/getTotalFee',
      setTotalFeeNull: 'tuitionFeePeriod/setTotalFeeNull',
      setReport: 'tuitionFeeReport/setReport',
    }),
    ...mapMutations('tuitionFeeReport', ['setCustomQuery']),
    countMoney(totalSumFee, totalMinusFee) {
      return totalSumFee - totalMinusFee
    },
    async handleFilter(filter) {
      this.pagination.page = 1
      await this.setCustomQuery(filter)
      await this.getReportByPagination(1, this.pagination.itemsPerPage)
      let params = {
        periodId: this.detailPeriod.id,
        gradeId: filter.grade ? filter.grade : null,
        classId: filter.class ? filter.class : this.user.role.type === 'teacher' ? this.ownClassIds : null,
        isUseNote: filter.isUseNote ? filter.isUseNote : null,
        isPaid: filter.isPaid ? filter.isPaid : null,
      }
      if (filter.student) {
        this.setReport(this.reports[0])
        params = { ...params, student: filter.student }
      }
      await this.setTotalFee(params)
    },
    async setTotalFee(params) {
      if (this.detailPeriod.id && this.detailPeriod.status === 'finished') {
        await this.getTotalFee(params)
      } else if (this.detailPeriod.status === 'created') {
        this.setTotalFeeNull()
      }
    },
    setPageText(page, itemsPerPage) {
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > this.totalItems || pageStop === -1 ? this.totalItems : pageStop
      this.pageText = `${pageStart}-${pageStop} trên ${this.totalItems}`
    },
    async getReportByPagination(page, itemsPerPage) {
      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: 'nameToNumber:ASC',
        period: this.$route.params.id,
        class_in: this.user.role.type === 'teacher' ? this.ownClassIds : null,
        ...this.customQuery,
      }
      this.loading = true
      await this.fetchReports(params)
      this.loading = false
      await this.setPageText(page, itemsPerPage)
    },
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.getReportByPagination(newOptions.page, newOptions.itemsPerPage)
        }
      },
      immediate: true,
    },
    async detailPeriod() {
      let params = {
        periodId: this.detailPeriod.id,
        classId: this.user.role.type === 'teacher' ? this.ownClassIds : null,
      }
      await this.setTotalFee(params)
    },
  },
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}

.tooltip {
  word-wrap: break-word;
}

div.note {
  max-width: 400px;
}

@media screen and (max-width: 1597px) {
  div.note {
    max-width: 300px;
  }
}

@media screen and (max-width: 1497px) {
  div.note {
    max-width: 200px;
  }
}
</style>
